export const MILLISECONDS_PER_SECOND = 1000;

export const AUTO_HIDE_TOAST_MS = 2000;
